import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IProviderDrawerInfo } from '.';

export const initialValues: IProviderDrawerInfo = {
  person: '',
  type: '',
  isCompany: false,
  isLocal: false,
  effectiveDate: '',
  expiryDate: '',
  providerStatus: 'ACTIVE',
};

export const drawerSections = (
  values: IProviderDrawerInfo,
  lovs: Record<string, Record<string, string>>,
  providerId: string
): IDynamicFormWidgetSection[] => {
  return [
    {
      inputs: {
        person: {
          name: 'person',
          title: 'Person',
          type: FormFieldType.autocomplete,
          placeholder: 'Type to search for Person',
          value: values?.person,
          conditionalHidden: () => {
            return !!providerId;
          },
          conditionalRequired: () => {
            return !providerId;
          },
        },
        type: {
          name: 'type',
          title: 'Type',
          type: FormFieldType.select,
          placeholder: 'Type',
          value: values?.type,
          conditionalDisable: () => {
            return !!providerId;
          },
          required: true,
          selectOptions: lovs?.type || {},
        },
        isCompany: {
          name: 'isCompany',
          title: 'Company',
          placeholder: 'Company',
          type: FormFieldType.switch,
          value: values?.isCompany,
        },
        isLocal: {
          name: 'isLocal',
          title: 'Local',
          placeholder: 'Local',
          type: FormFieldType.switch,
          value: values?.isLocal,
        },
        effectiveDate: {
          name: 'effectiveDate',
          title: 'Effective Date',
          type: FormFieldType.date,
          placeholder: 'Effective Date',
          value: values?.effectiveDate,
          required: true,
        },
        expiryDate: {
          name: 'expiryDate',
          title: 'Expiry Date',
          type: FormFieldType.date,
          placeholder: 'Expiry Date',
          value: values?.expiryDate,
          hidden: values?.providerStatus?.toUpperCase() !== 'INACTIVE',
          minDate: new Date(values?.effectiveDate),
        },
        providerStatus: {
          name: 'providerStatus',
          title: 'Status',
          placeholder: 'Status',
          type: FormFieldType.select,
          value: values?.providerStatus,
          conditionalHidden: () => {
            return !!providerId;
          },
          conditionalRequired: () => {
            return !providerId;
          },
          selectOptions: lovs?.providerStatus || {},
        },
      },
    },
  ];
};
